module.exports = __webpack_public_path__ + "static/img/7.65a1c8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/zh/7.png
// module id = QVa9
// module chunks = 0